module.exports = "/assets/91115ec12578575bc14be0b8e9482c33.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/PQ.png
// module id = 1725
// module chunks = 0